import AssetManagement from "./AssetManagement";

export default AssetManagement;
